export default __webpack_public_path__ + "static/media/home-yoga-meditation-benefits-of-yoga-img.c5090b91.jpg";